import { queryOptions, useQuery } from "@tanstack/react-query"

import { bffApi } from "../apiClient"
import queryKeys from "../queryKeys"

type UnavailableDatesPerCategoryResponse = {
  unavailableDatesPerCategory: string[]
}

type Params = {
  resortId: number | undefined
  categoryId: number | undefined
  year: number
  month: number
}

export const unavailableDatesPerCategoryQueryOptions = (params: Params) =>
  queryOptions({
    queryKey: queryKeys.unavailableDatesPerCategory(
      params.resortId,
      params.categoryId,
      params.year,
      params.month
    ),
    queryFn: async () => {
      const res = await bffApi.get<UnavailableDatesPerCategoryResponse>(
        "unavailable-category-dates",
        {
          params: {
            resortId: params.resortId,
            categoryId: params.categoryId,
            year: params.year,
            month: params.month,
          },
        }
      )
      return res.data.unavailableDatesPerCategory.map((date) => new Date(date))
    },
    enabled: Boolean(params.resortId) && Boolean(params.categoryId),
    staleTime: Infinity,
  })

const useUnavailableDatesPerCategoryQuery = (params: Params) =>
  useQuery(unavailableDatesPerCategoryQueryOptions(params))

export default useUnavailableDatesPerCategoryQuery
